import type { ReactNode } from "react";

interface BlankLayoutProps {
	children: ReactNode;
}

const BlankLayout = ({ children }: BlankLayoutProps) => <>{children}</>;

export default BlankLayout;
